import { appstr } from "./appstr";
import { GetFieldDefBy } from "./GetFieldDefBy";

export function ResolveFallback(result, dbObj, varName, curDef, docRef) {
  if (varName.length == 0) return;

  if (varName[0] == "$") {
    var v2 = "[" + varName + "]";
    result.fValue = docRef.ResolveReference(v2, dbObj);
    return;
  }
  var aClass = dbObj.GetParentClass();

  var fDef = aClass.GetFieldDefByName(varName);
  if (!fDef) fDef = aClass.GetFieldDefByLabel(varName);
  if (fDef == null || curDef == fDef) {
    if (fDef != null) var eMsg = "refcirc";
    else {
      var vlower = varName.toLowerCase();
      if (vlower.indexOf("todayf") == 0)
        result.fValue = '"' + docRef.HandleToday(varName, true) + '"';
      else {
        if (vlower.indexOf("today") == 0)
          result.fValue = '"' + docRef.HandleToday(varName, false) + '"';
        else {
          if (vlower.indexOf("subchart") == 0)
            result.fValue = '"' + docRef.GetCurrentSubChartName() + '"';
          else if (vlower.indexOf("division") == 0)
            result.fValue = '"' + docRef.GetDivisionName() + '"';
          else {
            eMsg = "refnotfound";
            result.fValue = "[" + appstr(eMsg) + "]";
          }
          if (result.fValue == "<" + appstr("Subchart") + ">") {
            eMsg = "refnotfound";
            result.fValue = "[" + appstr(eMsg) + "]";
          }
        }
      }
    }
  } else {
    var t = dbObj.GetFieldValue(fDef, true);
    if (t == null) t = "";
    result.fDef = fDef;
    result.fValue = t;
  }
}
